export default "__VITE_ASSET__BqzmQgrr__"